export default __webpack_public_path__ + "static/media/img.9b550b21.svg";